import Navbar from "./Navbar";
import "./app-wide.css";
import "./homepage.css";
import AboutSection from "./AboutSection";
import OurProductSection from "./ourproductsection";
import ProductCostSection from "./productcostsection";
import FaqSection from "./faqsection";
import ContactUs from "./contactus";
import FooterSection from "./footersection";

const HomePage = () => {
  
    return (
      <div className="homepage-whole">
        <div>
          <Navbar />
          <section id="about" className="about-section section-container">
            <AboutSection></AboutSection>
          </section>
          <section id="products" className="section-container">
            <div className="section-title-container">
              <p className="section-title-sub-header">Solutions</p>
              <h2 className="section-title-header">Our Products</h2>
            </div>
            <OurProductSection></OurProductSection>
          </section>
          <section id="cost" className="section-container">
            <div className="section-title-container"> 
              <p className="section-title-sub-header">Value</p>
              <h2 className="section-title-header">Cost & Pricing</h2>
            </div>
            <ProductCostSection></ProductCostSection>
          </section>
          <section id="faq" className="section-container section-faq-container">
            <div className="section-container-faq-left">
              <p className="section-title-sub-header">FAQ</p>
              <h2 className="section-title-header">Frequently Asked Questions</h2>
            </div>
            <FaqSection></FaqSection>
          </section>
          <section id="contactus"  className="section-container-contact-us">
            <ContactUs></ContactUs>
          </section>

          <footer className="footer-section-container">
            <FooterSection></FooterSection>
          </footer>
        </div>
      </div>
    );
  };
  
  export default HomePage;